import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Switch, Link } from 'react-router-dom'
import Landing from './components/landing';
import Problems from './components/problems';
import LeaderBoard from './components/leaderboard';
import { Context } from './context';
import Solve from './components/solve';
import Auth from './components/auth';
import Aos from 'aos'
import 'aos/dist/aos.css'
import Cookie from 'js-cookie'
import Axios from 'axios';
import { ENDPOINT, ShowNotification } from './utils/constants';
import Profile from './components/profile';
import { notifyRef } from './components/refs';
import Discussion from './components/discussions';
import CreateProblem from './components/createproblem';


function App() {

  const context = useContext(Context)
  useEffect(() => {
    console.log(window.location.pathname)

    autoAuth()
    Aos.init({})
  }, [])

  const autoAuth = () => {
    const token = Cookie.get('token')
    context.setMyToken(token)
    if (token) {
      try {
        ShowNotification("Please wait...", "green", -1)
      } catch (e) { }

      Axios.post(ENDPOINT + '/auth/autoauth', { token: token })
        .then(res => {
          if (res.data.success) {
            context.setIsLogedIn(true)
            try {
              ShowNotification("", "green", 1)
            } catch (e) { }
          }

        })
        .catch(err => {
          try {
            ShowNotification("Session expired! please login", "red", 4000)
          } catch (e) { }
        })
    }
  }

  ///to show a blank screen when user refrehes while logged in other than / and /profile
  if (window.location.pathname != '/' && !context.isLogedIn && window.location.pathname != '/profile') {
    return (
      <div className="blank">You need to be signed in</div>
    )
  }

  if (!context.isLogedIn) {
    return <Auth />
  }


  return (

    <div>
      <div style={{ position: 'absolute', width: '100%' }}>
        <Router>
          <Switch>
            <Route path="/" exact >
              {/* <Landing /> */}
              <Problems />
            </Route>
            <Route path="/problems">
              <Problems />
            </Route>
            <Route path="/leaderboard">
              <LeaderBoard />
            </Route>
            <Route path="/solve">
              {props => <Solve {...props} />}
            </Route>
            <Route path="/profile">
              <Profile />
            </Route>
            <Route path="/discussions">
              <Discussion />
            </Route>
            <Route path="/dev/create/makethisroutecomplicated">
              <CreateProblem />
            </Route>
          </Switch>
        </Router>
      </div>
      <div className="notif" ref={notifyRef} id="notif">
        <span id="notif-text"></span>
      </div>
      <div id="contextMenu" className="context-menu"
        style={{ display: 'none' }}>
        <ul>
          <li onClick={() => { window.location.reload() }}><a href="#">Refresh</a></li>
        </ul>
      </div>
    </div>
  );
}

export default App;
